var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 4.25,
    width: 5.5,
    height: 4,
    rx: 1,
    fill: "currentColor",
    stroke: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 5.5,
    height: 4,
    rx: 1,
    fill: "currentColor",
    stroke: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 10,
    width: 5.5,
    height: 4,
    rx: 1,
    fill: "currentColor",
    stroke: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 10,
    width: 5.5,
    height: 4,
    rx: 1,
    fill: "currentColor",
    stroke: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15.75,
    width: 5.5,
    height: 4,
    rx: 1,
    fill: "currentColor",
    stroke: "none"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 15.75,
    width: 5.5,
    height: 4,
    rx: 1,
    fill: "currentColor",
    stroke: "none"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 15.75,
    width: 5.5,
    height: 4,
    rx: 1,
    fill: "currentColor",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicing);
export default __webpack_public_path__ + "static/media/voicing.2c30c1431faba75d5a111c437ff21d8d.svg";
export { ForwardRef as ReactComponent };